import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class SupportApiService {

  private serviceDesks: any;
  private supportTickets: any;

  private SEPARATOR: string = "/";
  private API: string = "api/";
  private SUPPORT: string = "support/";
  private SERVICEDESK: string = "servicedesk/";
  private REQUEST: string = "request";
  private OEM: string = "oem/"
  private ACCOUNTS: string = "/accounts/"
  private USER: string = "/user/";
  private REQUESTTYPE: string = "/requesttype";
  private COMMENT: string = "/comment";
  private SUPPORTSERVICE: string = "supportservice/";
  private PRIORITY: string ="priority";
  private ATTACHMENT: string = "/attachment";
  private DOWNLOAD: string = "download";

  constructor(private http: HttpClient, private authService: AuthenticationService, private env: EnvService) { }

  public setServiceDesks(serviceDesks: any) {
    this.serviceDesks = serviceDesks;
  }

  public getServiceDesks() {
    return this.serviceDesks;
  }

  public setSupportTickets(tickets: any) {
    this.supportTickets = tickets;
  }

  public getSupportTickets() {
    return this.supportTickets;
  }

  executeGET(url: string, options = this.authService.httpOption): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(url, options).subscribe((data) => {
        var res = JSON.parse(JSON.stringify(data));
        resolve(res);
      },
        error => { reject(error); });
    });
  }

  executePOST(url: string, payload = {}, options = this.authService.httpOption): Promise<any> {
    console.log("payload::", payload);
    return new Promise((resolve, reject) => {
      this.http.post(url, payload, options).subscribe((data) => {
        var res = JSON.parse(JSON.stringify(data));
        console.log("response : ", res);
        resolve(res);
      },
        error => { reject(error); });
    });
  }

  getSupportUser(userId: string): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORTSERVICE +
      this.OEM + this.authService.loggedInUser.enterpriseId +
      this.ACCOUNTS + this.authService.loggedInUser.accountId + this.USER + userId;

    return this.executeGET(url);
  }

  addServiceRequest(organizationId: string, payload: any): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.REQUEST;
    this.authService.httpOption.params = null;

    let params = new HttpParams();
    params = params.append('organizationId', organizationId);
    let httpOption = Object.assign({}, this.authService.httpOption);
    httpOption.params = params;

    return this.executePOST(url, payload, httpOption);
  }

  getServiceRequest(userId: string, organizationId: string, requestOwnership: string, maxResults=10, startAt=0): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.REQUEST;

    let params = new HttpParams();
    params = params.append('customerId', userId);
    params = params.append('organizationId', organizationId);
    params = params.append('requestOwnership', requestOwnership);
    params = params.append('maxResults', maxResults.toString());
    params = params.append('startAt', startAt.toString());
    let httpOption = Object.assign({}, this.authService.httpOption);
    httpOption.params = params;

    return this.executeGET(url, httpOption);
  }

  getRequestType(serviceDeskId: string, groupId = "-1"): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + serviceDeskId + this.REQUESTTYPE;

    let httpOption = Object.assign({}, this.authService.httpOption);
    if (groupId != "-1") {
      let params = new HttpParams();
      params = params.append('groupId', groupId);
      httpOption.params = params;
    }

    return this.executeGET(url, httpOption);
  }

  addCommentRequest(userId: string, issueId: string, payload): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.REQUEST + this.SEPARATOR + issueId + this.COMMENT;

    let httpOption = Object.assign({}, this.authService.httpOption);
    let params = new HttpParams();
    params = params.append('customerId', userId);
    httpOption.params = params;

    return this.executePOST(url, payload, httpOption);
  }

  getRequestComments(userId: string, issueId: string): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.REQUEST + this.SEPARATOR + issueId + this.COMMENT;

    let httpOption = Object.assign({}, this.authService.httpOption);
    let params = new HttpParams();
    params = params.append('customerId', userId);
    httpOption.params = params;

    return this.executeGET(url, httpOption);
  }

  getRequestPriorities(): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.PRIORITY;

    return this.executeGET(url);
  }

  addAttachmentToRequest(userId: string, issueId: string, formData: FormData, comment: string) {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.REQUEST + this.SEPARATOR + issueId + this.ATTACHMENT;

    let httpOption = {
			headers: new HttpHeaders({})
    };

    let params = new HttpParams();
    params = params.append('comment', comment);
    params = params.append('customerId', userId);
    httpOption["params"] = params;

    return this.executePOST(url, formData, httpOption);
  }

  downloadAttachment(userId: string, attachmentUrl: string): Promise<any> {
    var url = this.env.BASE_URL + this.SUPPORT + this.API + this.SERVICEDESK + this.DOWNLOAD;

    let httpOption = {
      responseType: 'blob' as 'json',
			headers: new HttpHeaders({})
    };
    let params = new HttpParams();
    params = params.append('attachmentUrl', attachmentUrl);
    params = params.append('customerId', userId);
    httpOption["params"] = params;

    return new Promise((resolve, reject) => {
      this.http.get(url, httpOption).subscribe((data) => {
        resolve(data);
      },
        error => { reject(error); });
    });
  }


}
